import { render, staticRenderFns } from "./ComboStatusLead.vue?vue&type=template&id=a2135f42"
import script from "./ComboStatusLead.vue?vue&type=script&lang=ts"
export * from "./ComboStatusLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports